import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=auth
  const [token, setToken] = useState(localStorage.getItem("fx_token"));

  const loadMe = useCallback(async () => {
    const t = localStorage.getItem("fx_token");
    if (!t) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("fx_token");
      setToken(null);
      setUser(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const applyAuth = (tk, usr) => {
    localStorage.setItem("fx_token", tk);
    setToken(tk);
    setUser(usr);
  };

  const login = async (email, password, captchaToken) => {
    const { data } = await api.post("/auth/login", { email, password, captcha_token: captchaToken });
    if (data.requires_2fa) return data; // { requires_2fa, tmp_token }
    applyAuth(data.token, data.user);
    return data.user;
  };

  const verify2fa = async (tmpToken, code) => {
    const { data } = await api.post("/auth/2fa/verify", { tmp_token: tmpToken, code });
    applyAuth(data.token, data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    applyAuth(data.token, data.user);
    return data.user;
  };

  const impersonate = async (customerId) => {
    const { data } = await api.post(`/admin/customers/${customerId}/impersonate`);
    applyAuth(data.token, data.user);
    return data.user;
  };

  const stopImpersonation = async () => {
    const { data } = await api.post("/admin/impersonate/stop");
    applyAuth(data.token, data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("fx_token");
    setToken(null);
    setUser(false);
  };

  const refreshUser = loadMe;

  return (
    <AuthContext.Provider value={{ user, token, login, verify2fa, register, impersonate, stopImpersonation, logout, refreshUser, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
